import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { ToastrService as ToasterService } from 'ngx-toastr';

import { SHARED_ENVIRONMENT, SharedEnvironment } from '@sd-portal/shared/environment';
import { AppMonitoringService } from './app-monitoring.service';

const WHITELISTED_RESPONSE_CODES = [
  422 // Unprocessable Entity
];

export interface ExceptionServiceResult<T> {
  status: number;
  statusText: string;
  err: T;
}

@Injectable()
export class ExceptionService {
  constructor(
    private readonly toasterService: ToasterService,
    private readonly appMonitoringService: AppMonitoringService,
    @Inject(SHARED_ENVIRONMENT) private readonly environment: SharedEnvironment
  ) {}

  catchBadResponse = (
    errorResponse: HttpErrorResponse
  ): Observable<ExceptionServiceResult<unknown>> => {
    const res = errorResponse;
    const err = res.error;

    const status = res.status;

    // Log to Application Insights
    this.appMonitoringService.logException(err);

    // TODO: suppressing error alerts for demo purposes - should unblock eventually
    if (this.environment.local && WHITELISTED_RESPONSE_CODES.indexOf(status) < 0) {
      let emsg = 'An error has occurred';
      if (!this.environment.production && err && err.message) {
        emsg = err.message;
      }

      this.toasterService.error('Bad Request', emsg);
    }

    return throwError({ status: res.status, statusText: res.statusText, err });
  };
}
